import React from 'react';
import PropTypes from 'prop-types';

const SingleCheckbox = (props) => {
    const { id, label, isChecked, onChange, className, darkOption, disabled, checkboxClassName, 'data-testid': dataTestId } = props;

    return (
        <div className="row">
            <div className="col-12">
                <input
                    type="checkbox"
                    name={id}
                    id={id}
                    className={`standalone-checkbox ${darkOption ? 'dark' : ''}`}
                    checked={isChecked}
                    onChange={onChange}
                    disabled={disabled}
                    data-testid={dataTestId && `${dataTestId}.checkbox`}
                />
                <label htmlFor={id} className={className} data-testid={dataTestId && `${dataTestId}.label`}><span className={checkboxClassName} />{label}</label>
            </div>
        </div>
    );
};

SingleCheckbox.propTypes = {
    id: PropTypes.bool,
    label: PropTypes.string,
    isChecked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    darkOption: PropTypes.bool,
    disabled: PropTypes.bool,
    checkboxClassName: PropTypes.string,
    'data-testid': PropTypes.string,
};

SingleCheckbox.defaultProps = {
    id: '',
    label: '',
    isChecked: false,
    className: '',
    darkOption: false,
    disabled: false,
    checkboxClassName: '',
    'data-testid': undefined,
};

export default SingleCheckbox;
